"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState = this.#createEmptyState()){
        this.initialState = initialState;
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        if (this.status === "playing") {
            const newState = this.state.map((row)=>this.#mergeCells(row));
            this.#handleMove(newState);
        }
    }
    moveRight() {
        if (this.status === "playing") {
            const newState = this.state.map((row)=>{
                const reversedRow = row.slice().reverse();
                const mergedRow = this.#mergeCells(reversedRow);
                return mergedRow.reverse();
            });
            this.#handleMove(newState);
        }
    }
    moveUp() {
        if (this.status === "playing") {
            const transposedState = this.#transpose(this.state);
            const newState = transposedState.map((row)=>this.#mergeCells(row));
            this.#handleMove(this.#transpose(newState));
        }
    }
    moveDown() {
        if (this.status === "playing") {
            const transposedState = this.#transpose(this.state);
            const newState = transposedState.map((row)=>{
                const reversedRow = row.slice().reverse();
                const mergedRow = this.#mergeCells(reversedRow);
                return mergedRow.reverse();
            });
            this.#handleMove(this.#transpose(newState));
        }
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.state;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        this.#addRandomTile();
        this.#addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = "idle";
    }
    // Add your own methods here
    #createEmptyState() {
        return Array.from({
            length: 4
        }, ()=>Array(4).fill(0));
    }
    #getEmptyCells() {
        const emptyCells = [];
        this.state.forEach((row, rowIndex)=>{
            row.forEach((cell, cellIndex)=>{
                if (cell === 0) emptyCells.push({
                    rowIndex: rowIndex,
                    cellIndex: cellIndex
                });
            });
        });
        return emptyCells;
    }
    #addRandomTile() {
        const emptyCells = this.#getEmptyCells();
        if (emptyCells.length === 0) return;
        const randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        const value = Math.random() > 0.1 ? 2 : 4;
        this.state[randomCell.rowIndex][randomCell.cellIndex] = value;
    }
    #mergeCells(row) {
        const mergedRow = row.filter((cell)=>cell !== 0);
        const newRow = [];
        let i = 0;
        while(i < mergedRow.length)if (mergedRow[i] === mergedRow[i + 1]) {
            newRow.push(mergedRow[i] * 2);
            this.score += mergedRow[i] * 2;
            i += 2;
        } else {
            newRow.push(mergedRow[i]);
            i += 1;
        }
        newRow.push(...Array(4 - newRow.length).fill(0));
        return newRow;
    }
    #transpose(matrix) {
        return matrix[0].map((_, colIndex)=>matrix.map((row)=>row[colIndex]));
    }
    #willStateChange(newState) {
        return JSON.stringify(this.state) !== JSON.stringify(newState);
    }
    #isWin() {
        this.status = this.state.some((row)=>row.includes(2048)) ? "win" : this.status;
    }
    #isLose() {
        for (const row of this.state){
            if (row.some((i)=>i === 0)) return false;
            for(let i = 0; i < row.length; i++){
                if (row[i] === row[i + 1]) return false;
            }
        }
        for(let c = 0; c < 4; c++){
            const row = [
                this.state[0][c],
                this.state[1][c],
                this.state[2][c],
                this.state[3][c]
            ];
            for(let i = 0; i < row.length; i++){
                if (row[i] === row[i + 1]) return false;
            }
        }
        return true;
    }
    #handleMove(newState) {
        if (this.#willStateChange(newState)) {
            this.state = newState;
            this.#addRandomTile();
            this.#isWin();
            if (this.#isLose()) this.status = "lose";
        }
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
// Uncomment the next lines to use your game instance in the browser
// [
//   [2, 0, 2, 2],
//   [0, 2, 2, 2],
//   [2, 2, 0, 2],
//   [2, 2, 2, 0],
// ]
// Write your code here
const $09e991522ca7e64e$var$startButton = document.querySelector(".button", ".start");
function $09e991522ca7e64e$var$updateTable() {
    const gameState = $09e991522ca7e64e$var$game.getState();
    const table = document.querySelector(".game-field");
    const tbody = table.querySelector("tbody");
    tbody.innerHTML = "";
    for(let i = 0; i < gameState.length; i++){
        const row = gameState[i];
        const tr = document.createElement("tr");
        tr.className = "field-row";
        for(let j = 0; j < row.length; j++){
            const cell = row[j];
            const td = document.createElement("td");
            td.textContent = cell !== 0 ? cell : "";
            td.className = cell !== 0 ? `field-cell field-cell--${cell}` : "field-cell";
            tr.appendChild(td);
        }
        tbody.appendChild(tr);
    }
}
function $09e991522ca7e64e$var$updateScore() {
    const gameScore = document.querySelector(".game-score");
    gameScore.innerText = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$handleMessages(action, type) {
    const startMessage = document.querySelector(".message-start");
    const winMessage = document.querySelector(".message-win");
    const loseMessage = document.querySelector(".message-lose");
    if (action === "hide") switch(type){
        case "start":
            startMessage.classList.add("hidden");
            break;
        case "win":
            winMessage.classList.add("hidden");
            break;
        case "lose":
            loseMessage.classList.add("hidden");
            break;
        default:
            break;
    }
    if (action === "show") switch(type){
        case "start":
            startMessage.classList.remove("hidden");
            break;
        case "win":
            winMessage.classList.remove("hidden");
            break;
        case "lose":
            loseMessage.classList.remove("hidden");
            break;
        default:
            break;
    }
}
function $09e991522ca7e64e$var$handleGameStatus() {
    switch($09e991522ca7e64e$var$game.getStatus()){
        case "win":
            $09e991522ca7e64e$var$handleMessages("show", "win");
            break;
        case "lose":
            $09e991522ca7e64e$var$handleMessages("show", "lose");
            break;
        default:
            break;
    }
}
function $09e991522ca7e64e$var$updateGame() {
    $09e991522ca7e64e$var$updateTable();
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$handleGameStatus();
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    switch($09e991522ca7e64e$var$game.getStatus()){
        case "idle":
            $09e991522ca7e64e$var$game.start();
            $09e991522ca7e64e$var$updateTable();
            $09e991522ca7e64e$var$startButton.className = "button restart";
            $09e991522ca7e64e$var$startButton.textContent = "Restart";
            $09e991522ca7e64e$var$handleMessages("hide", "start");
            $09e991522ca7e64e$var$updateScore();
            break;
        case "playing":
            $09e991522ca7e64e$var$game.restart();
            $09e991522ca7e64e$var$updateTable();
            $09e991522ca7e64e$var$startButton.className = "button start";
            $09e991522ca7e64e$var$startButton.textContent = "Start";
            $09e991522ca7e64e$var$handleMessages("show", "start");
            $09e991522ca7e64e$var$updateScore();
            break;
        case "win":
            $09e991522ca7e64e$var$game.restart();
            $09e991522ca7e64e$var$updateTable();
            $09e991522ca7e64e$var$startButton.className = "button start";
            $09e991522ca7e64e$var$startButton.textContent = "Start";
            $09e991522ca7e64e$var$handleMessages("hide", "win");
            $09e991522ca7e64e$var$handleMessages("show", "start");
            $09e991522ca7e64e$var$updateScore();
            break;
        case "lose":
            $09e991522ca7e64e$var$game.restart();
            $09e991522ca7e64e$var$updateTable();
            $09e991522ca7e64e$var$startButton.className = "button start";
            $09e991522ca7e64e$var$startButton.textContent = "Start";
            $09e991522ca7e64e$var$handleMessages("hide", "lose");
            $09e991522ca7e64e$var$handleMessages("show", "start");
            $09e991522ca7e64e$var$updateScore();
            break;
        default:
            break;
    }
});
document.addEventListener("keydown", (e)=>{
    switch(e.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            $09e991522ca7e64e$var$updateGame();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            $09e991522ca7e64e$var$updateGame();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            $09e991522ca7e64e$var$updateGame();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            $09e991522ca7e64e$var$updateGame();
            break;
        default:
            break;
    }
});


//# sourceMappingURL=index.e99d90ef.js.map
